function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#0B474B",
  fillRule: "evenodd",
  d: "M8 12.048L3.65 14.29a.2.2 0 01-.289-.21l.79-4.83L.673 5.808a.198.198 0 01.11-.339l4.837-.743 2.2-4.37a.2.2 0 01.358 0l2.2 4.37 4.837.743a.199.199 0 01.11.339L11.85 9.251l.788 4.83a.2.2 0 01-.289.209L8 12.048z"
})));